import {type AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas.ts'
import {type PerksListBody, ViewPopupBecomeMember} from './ViewPopupBecomeMember.ts'
import {LobbyImage} from '@colonist/types'

export class ViewPopupBecomeMemberBasic extends ViewPopupBecomeMember {
    constructor(checkAction: () => void, analyticEventValue?: AnalyticEventValue, xAction: () => void = () => undefined, showXButton: boolean = false) {
        super(checkAction, analyticEventValue, xAction, showXButton)
    }

    // eslint-disable-next-line class-methods-use-this
    protected getBenefits(): PerksListBody[] {
        return [
            {
                image: LobbyImage.NoAds,
                title: {key: 'strings:popups.becomeAMember.perks.noAds.title'},
                description: {key: 'strings:popups.becomeAMember.perks.noAds.description'},
            },
            {
                image: LobbyImage.FullScreenExpand,
                title: {key: 'strings:popups.becomeAMember.perks.fullscreen.title'},
                description: {key: 'strings:popups.becomeAMember.perks.fullscreen.description'},
            },
            {
                image: LobbyImage.Colors,
                title: {key: 'strings:popups.becomeAMember.perks.colors.title'},
                description: {key: 'strings:popups.becomeAMember.perks.colors.description'},
            },
        ]
    }
}
